import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { 
  HomePageSkeleton, 
  AboutPageSkeleton, 
  ContactPageSkeleton, 
  CoursePageSkeleton 
} from "./components/skeletons";

// Lazy load all pages for code splitting
const HomePage = lazy(() => import("./pages/HomePage"));
const GroupCoursePage = lazy(() => import("./pages/GroupCoursePage"));
const IndividualCoursePage = lazy(() => import("./pages/IndividualCoursePage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));

// Suspense fallback component that shows appropriate skeleton
const PageFallback = ({ path }) => {
  const skeletonMap = {
    '/': HomePageSkeleton,
    '/acerca': AboutPageSkeleton,
    '/contacto': ContactPageSkeleton,
    '/cursos/grupal': CoursePageSkeleton,
    '/cursos/individual': CoursePageSkeleton,
  };
  
  const SkeletonComponent = skeletonMap[path] || HomePageSkeleton;
  return <SkeletonComponent />;
};

// Route wrapper with suspense (without page transition)
const SuspenseRoute = ({ path, children }) => (
  <Suspense fallback={<PageFallback path={path} />}>
    {children}
  </Suspense>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route 
            path="/" 
            element={
              <SuspenseRoute path="/">
                <HomePage />
              </SuspenseRoute>
            } 
          />
          <Route 
            path="/acerca" 
            element={
              <SuspenseRoute path="/acerca">
                <AboutPage />
              </SuspenseRoute>
            } 
          />
          <Route 
            path="/cursos/grupal" 
            element={
              <SuspenseRoute path="/cursos/grupal">
                <GroupCoursePage />
              </SuspenseRoute>
            } 
          />
          <Route 
            path="/cursos/individual" 
            element={
              <SuspenseRoute path="/cursos/individual">
                <IndividualCoursePage />
              </SuspenseRoute>
            } 
          />
          <Route 
            path="/contacto" 
            element={
              <SuspenseRoute path="/contacto">
                <ContactPage />
              </SuspenseRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
